import React from 'react';
import './index.scss';
import {  Grid, Form, Header, Button, Loader } from 'semantic-ui-react';
import { Controller } from "react-hook-form";
import { PhoneUtil } from 'utils';
import NestedDropdown from 'dyl-components/atoms/NestedDropdown';


const OfficeViewCallResults = ({ 
    control,
    callTagOptions,
    relatedToOptions,
    onSave,
    onSaveDisabled = false,
    callResultsDisabled = false,
    callTagDisabled = false,
    relatedToDisabled = false,
    onChangeResults = () => {},
    onChangeNotes = () => {},
    isSaveLoading = false,
    isDialer
 }) => {
    const callResultField = (
        <Controller
            name={'call_result'}
            control={control}
            render={({ field: { name, value, onChange } }) => (
                <Form.Select
                    name={name}
                    value={value}
                    search
                    onChange={(_, { value }) => {
                        onChange({
                            target: { name, value },
                        });
                        onChangeResults(value);
                    }}
                    placeholder="Call result"
                    selectOnBlur={false}
                    options={PhoneUtil.CALL_RESULT_OPTIONS}
                    fluid
                    disabled={callResultsDisabled}
                    scrolling
                    className='CallResults__dropdown'
                />
            )}
        />
    );
    const callTagField = (
        <Controller
            name={'call_tag'}
            control={control}
            render={({ field: { name: parentName, value: parentValue, onChange: parentOnChange } }) => (
                <Controller
                    name='sub_tag'
                    control={control}
                    render={({ field: { name, value, onChange } }) => (
                        <Form.Field
                            disabled={callTagDisabled}
                            control={NestedDropdown}
                            allowedToSelectParentOnly
                            child_value={value}
                            parent_value={parentValue}
                            nested_options={callTagOptions}
                            onChange={(_, { parent_value, child_value }) => {
                                parentOnChange({ target: { name: parentName, value: parent_value } });
                                onChange({ target: { name, value: child_value } });
                            }}
                            placeholder='Call Tags'
                            display_parent
                            selection
                            pointing='top'
                                        className='CallResults__dropdown'
                        />
                    )}
                />
            )}
        />
    );
    const relatedToField = (
        <Controller
            name={'related_to'}
            control={control}
            render={({ field: { name, value, onChange } }) => (
                <Form.Select
                    name={name}
                    value={value}
                    search
                    onChange={(_, { value }) => {
                        onChange({
                            target: { name, value },
                        });
                    }}
                    placeholder="Related to"
                    selectOnBlur={false}
                    options={relatedToOptions}
                    fluid
                    disabled={relatedToDisabled}
                    clearable
                />
            )}
        />
    );
    
    return (
        <Grid className={`OfficeViewCallResults${isDialer ? ` OfficeViewCallResults--dialer` : ''}`} columns="equal">
            {!isDialer ? (
                <Grid.Row>
                    <Grid.Column>
                        {callResultField}
                    </Grid.Column>
                    <Grid.Column>
                        {callTagField}
                    </Grid.Column>
                    <Grid.Column>
                        {relatedToField}
                    </Grid.Column>
                </Grid.Row>
            ) : (
                <>
                    <Grid.Row columns="equal">
                        <Grid.Column>
                            {callResultField}
                            <Controller 
                                name='refrain_from_calling'
                                control={control}
                                render={({ field: { onChange, name, value } }) => (
                                    <Form.Checkbox
                                        label='Suspend Call'
                                        onChange={(_, { checked }) => {
                                            onChange({ target: { name, value: checked } })
                                        }}
                                        checked={value}
                                        style={{ marginTop: 10 }}
                                        disabled // TODO: enable when ready
                                    />
                                )}
                            />
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row columns="equal">
                        <Grid.Column>
                            {callTagField}
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row columns="equal">
                        <Grid.Column>
                            {relatedToField}
                        </Grid.Column>
                    </Grid.Row>
                </>
            )}
            <Grid.Row>
                <Grid.Column width={!isDialer ? 14 : 16}>
                    <Controller
                        name='call_notes'
                        control={control}
                        render={({ field: { onChange, value } }) => (
                            <>
                                <Header as="h6" style={{marginBottom: 8}}>Call Notes</Header>
                                <Form.TextArea
                                    onChange={e=>{
                                        onChange(e);
                                    }}
                                    value={value}
                                    rows={4}
                                    onBlur={(e) => {
                                        onChangeNotes(e.target.value)
                                    }}
                                />
                            </>
                        )}
                    />
                </Grid.Column>
                {!isDialer && (
                    <Grid.Column verticalAlign='bottom' style={{marginBottom: 5}}>
                        <Button fluid onClick={onSave} disabled={onSaveDisabled} className='CallResults__saveButton'>
                            {isSaveLoading ? (
                                <Loader inline active size='small' />
                            ) : (
                                "Save"
                            )}
                        </Button>
                    </Grid.Column>
                )}
            </Grid.Row>
        </Grid>
    )
};

export default OfficeViewCallResults;
